(ns storrito.caption-limits
  "The text limits of Storrito's own YouTube and TikTok integrations,
   shared by their schedule commands, which shorten a longer text, and
   the scheduling page, which says so.")

(def youtube-description-max-bytes
  "YouTube counts a description's UTF-8 bytes, not its characters."
  5000)

(def tiktok-caption-max-length
  "A TikTok video's caption, sent as its title."
  2200)

(def tiktok-photo-description-max-length
  "A TikTok photo's description; its title is validated instead."
  4000)
